import { SuppliedProduct } from 'types/common'
import { APICfg } from 'services/api/api'
import { ApiCustomer, APICustomerITA, Customer, customerUserWrite } from './pmi'

type APISupplierITA = APICustomerITA & {
  category: SuppliedProduct
}
export type SupplierITA = APISupplierITA

export type APISupplier = ApiCustomer & {
  category: SuppliedProduct
}

export type Supplier = Customer & {
  category: SuppliedProduct
}

const apiCfg: APICfg = {
  endpoint: 'usersupplier',
  parse: (res: APISupplier): Supplier => res,
  write: customerUserWrite,
}

export default apiCfg
